// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin-top: 3rem;
  height: 50vh;
  display: flex;
  position: absolute;
  z-index: 99999;
  top: 50%;
  left: 50%;
  margin-top: -140px; /* this is half the height of your div*/
  margin-left: -250px; /*this is half of width of your div*/
}

.spinner-wrapper {
  width: 250px;
  height: 130px;
  /* border: 1px solid #000; */
  position: absolute;
  top: 0%;
  z-index: 999;
  background: #fff;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.spinner-wrapper p {
  font-size: 1.2rem;
  font-weight: bold;
  margin-left: 2rem;
}

.spinner {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 5px solid;
  border-color: #dedede;
  border-right-color: var(--primaryColor);
  animation: spinner-d3wgkg 1s infinite linear;
}

.ai-diamond {
  position: absolute;
  display: block;
  top: 50px;
  left: 47px;
  background-image: url('aidiamond.svg');
  background-size: cover;
  height: 30px;
  width: 30px;
  z-index: 999;
}

@keyframes spinner-d3wgkg {
  to {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/progress-spinner/progress-spinner.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EAIE,kBAAA;EACA,cAAA;EACC,QAAA;EACH,SAAA;EACA,kBAAA,EAAA,uCAAA;EACA,mBAAA,EAAA,oCAAA;AAFF;;AAIC;EACG,YAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EAEA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,iDAAA;AAFJ;AAII;EACI,iBAAA;EACJ,iBAAA;EACA,iBAAA;AAFJ;;AAKA;EACG,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,4CAAA;AAFH;;AAIA;EACI,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,sCAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AADJ;;AAGA;EACG;IACG,wBAAA;EAAJ;AACF","sourcesContent":[":host{\n  margin-top:3rem;\n  height: 50vh;\n  display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   position: relative;\n    position: absolute;\n    z-index: 99999;\n     top:50%;\n  left:50%;\n  margin-top:-140px; /* this is half the height of your div*/  \n  margin-left:-250px; /*this is half of width of your div*/\n}\n .spinner-wrapper{\n    width: 250px;\n    height: 130px;\n    /* border: 1px solid #000; */\n    position: absolute;\n   // left:calc(55% - 250px);\n    top:0%;\n    z-index: 999;\n    background: #fff;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n\n    p{\n        font-size: 1.2rem;\n    font-weight: bold;\n    margin-left: 2rem;\n    }\n }\n.spinner {\n   width:70px;\n   height:70px;\n   border-radius: 50%;\n   border:5px solid;\n   border-color: #dedede;\n   border-right-color: var(--primaryColor);\n   animation: spinner-d3wgkg 1s infinite linear;\n}\n.ai-diamond{\n    position: absolute;\n    display: block;\n    top:50px;\n    left:47px;\n    background-image: url('../../assets/images/aidiamond.svg');\n    background-size: cover;\n    height:30px;\n    width:30px;\n    z-index:999;\n  }\n@keyframes spinner-d3wgkg {\n   to {\n      transform: rotate(1turn);\n   }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
